


































































































































































import Vue from 'vue';
import FirebaseWeb from '../firebase';
const firebase = new FirebaseWeb();

import BarTop from '@/components/BarTop.vue';
import ContainerApp from '@/components/ContainerApp.vue';
import ContainerMenu from '@/components/ContainerMenu.vue';
import {
    navigateToPath,
    getInitials,
    getAllTasksForUser,
    getAllTaskTypesForUser,
    getAllNotificationsForUser,
    getTextColorByBg,
    getRandomHexColor,
    // @ts-ignore
} from '@/util';
export default Vue.extend({
    name: 'Profile',
    components: {
        BarTop,
        ContainerApp,
        ContainerMenu,
    },
    data() {
        return {
            newTypeColor: '#8E00FF',
            taskTypeLabel: '',
            taskTypesLoading: false,
            editName: false,
            userUpdating: false,
            user: {
                displayName: '',
                email: '',
            },
        };
    },
    computed: {
        currentUser() {
            return this.$store.getters.user;
        },
        types() {
            return this.$store.getters.types;
        },
    },
    methods: {
        onNameEdit() {
            this.resetEditFlags();
            this.editName = true;
            this.focusByRef('nameEdit');
        },
        onUserEdit() {
            firebase
                .updateUserProfile(this.user)
                .then(() => {})
                .catch(() => {
                    this.$store.dispatch(
                        'SHOW_SNACK',
                        this.$t('toast.error.name.edit')
                    );
                })
                .finally(() => {
                    this.resetEditFlags();
                });
        },
        resetEditFlags() {
            this.editName = false;
        },
        navigateToHome() {
            navigateToPath('/home');
        },
        getInitials(name: any) {
            return getInitials(name);
        },
        onAddTaskTypeSubmit() {
            this.addTaskType();
        },
        getTextColor(color: any) {
            return getTextColorByBg(color);
        },
        loadPage() {
            return Promise.all([
                getAllTasksForUser(this.$store.getters.user),
                getAllTaskTypesForUser(this.$store.getters.user),
                getAllNotificationsForUser(this.$store.getters.user),
            ]);
        },
        addTaskType() {
            this.taskTypesLoading = true;
            let newTaskType = {
                label: this.taskTypeLabel.trim(),
                color: this.newTypeColor.trim(),
            };
            firebase
                .addTaskType(this.$store.getters.user, newTaskType)
                .then((response) => {
                    this.$store.dispatch('LANDING_VISITED', false);
                    this.$store.dispatch('SET_TYPES', [
                        {
                            id: response.id,
                            ...newTaskType,
                        },
                        ...this.types,
                    ]);
                    this.taskTypeLabel = '';
                })
                .catch((err) => {
                    this.$store.dispatch(
                        'SHOW_SNACK',
                        this.$t('toast.error.label')
                    );
                })
                .finally(() => {
                    this.taskTypesLoading = false;
                });
        },
        focusByRef(name: any) {
            this.$nextTick(() => {
                //@ts-ignore
                this.$refs[name].focus();
            });
        },
    },
    mounted() {
        if (!this.$store.getters.landingVisited) {
            this.taskTypesLoading = true;
            this.loadPage()
                .catch((e) => e)
                .then((response) => {
                    this.$store.dispatch('SET_TASKS', response[0]);
                    this.$store.dispatch('SET_TYPES', response[1]);
                    this.$store.dispatch('SET_NOTIFICATIONS', response[2]);
                    this.$store.dispatch('LANDING_VISITED', true);
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.taskTypesLoading = false;
                });
        }
        this.user = this.currentUser;
        this.newTypeColor = getRandomHexColor();
    },
});
